





































































import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import { PasosCrud } from '@/reusable/Mantenedor/mantenedorUtils';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import CrudStepsNavBar from '@/reusable/Mantenedor/CrudStepsNavBar.vue';
import ContenidoModal from '@/reusable/Modal/ContenidoModal.vue';
import { Funcionalidades } from '@/config/funcionalidades';
import ConfigurarDetalleForm from '@/pantallas/OrdenesServicio/ConfigurarDetalleForm.vue';
import CuadreServicioForm from '@/pantallas/OrdenesServicio/CuadreServicioForm.vue';
@Component({
  components: {
    ModalMantenedor,
    CabeceraModal,
    CrudStepsNavBar,
    ContenidoModal,
    ConfigurarDetalleForm,
    CuadreServicioForm,
  },
})
export default class VerDetalleCuadratura extends Vue {
  @Prop({ default: false }) readonly value!: boolean;
  @Prop() readonly detalleId: string; // Nueva prop para recibir el ID
  @Prop() readonly detallePatente!: string;
  @Prop() readonly Categoriaglosa!: string;
  @Prop() readonly Cuadratura!: string;
  @Prop() readonly detalleglosa!: string;
  step: string = 'os';
  mostrarDetalle: boolean = this.value;
  loading: boolean = false;
  dialog: boolean = true;
  pasoActivoIndex: number = 1;
  estadoLocal: string = this.Cuadratura;

  @Watch('value')
  onValueChanged(newValue: boolean) {
    this.dialog = newValue;
  }

  @Watch('patenteSeleccionada')
  onPatenteSeleccionadaChanged(newValue: string, oldValue: string) {}

  handleCerrar() {
    this.dialog = false;
    this.$emit('update:value', false); // Asegúrate de emitir este evento para que el componente padre pueda reaccionar a él
  }

  @Watch('step')
  onStepChanged(newStep: string, oldStep: string) {
    if (newStep !== oldStep) {
      // Aquí se pueden realizar acciones específicas dependiendo del paso actual
      switch (newStep) {
        case 'os':
          break;
        case 'cuadre':
          break;
      }
    }
  }
  data() {
    return {
      estadoLocal: this.Cuadratura, // Estado local que se puede actualizar
    };
  }

  handleEstadoActualizado(nuevoEstado: string) {
    this.estadoLocal = nuevoEstado;
    this.$emit('estadoActualizado', nuevoEstado);
  }
  @Watch('Cuadratura')
  onCuadraturaChanged(newVal: string) {
    this.estadoLocal = newVal;
  }
  handleGlosaUpdated(data: { glosa: string; categoria: string }) {
    // Propaga el evento al componente padre si es necesario
    this.$emit('glosaUpdated', data);
  }
}
